import { supabase } from './supabaseClient';

export async function fetchDrillWords(userId: string): Promise<string[]> {
  const { data, error } = await supabase
    .from('user_drill_words')
    .select('word')
    .eq('user_id', userId)
    .order('added_at', { ascending: true });
  if (error) { console.error('fetchDrillWords error:', error); return []; }
  return (data ?? []).map((r: { word: string }) => r.word);
}

export async function addDrillWords(userId: string, words: string[]): Promise<void> {
  if (words.length === 0) return;
  const rows = words.map(word => ({ user_id: userId, word }));
  const { error } = await supabase
    .from('user_drill_words')
    .upsert(rows, { onConflict: 'user_id,word', ignoreDuplicates: true });
  if (error) console.error('addDrillWords error:', error);
}

export async function removeDrillWord(userId: string, word: string): Promise<void> {
  const { error } = await supabase
    .from('user_drill_words')
    .delete()
    .eq('user_id', userId)
    .eq('word', word);
  if (error) console.error('removeDrillWord error:', error);
}
